import React, { useState } from 'react';

export default function SystemAdmin() {
  const [activeTab, setActiveTab] = useState('users');

  const users = [
    { id: 1, name: 'Rajesh Kumar', role: 'CEO', email: 'rajesh@company.com', status: 'active', lastLogin: '2024-01-20' },
    { id: 2, name: 'Priya Sharma', role: 'Director', email: 'priya@company.com', status: 'active', lastLogin: '2024-01-19' },
    { id: 3, name: 'Amit Patel', role: 'Operations Head', email: 'amit@company.com', status: 'active', lastLogin: '2024-01-20' },
    { id: 4, name: 'Sunita Gupta', role: 'HO Manager', email: 'sunita@company.com', status: 'inactive', lastLogin: '2024-01-15' },
  ];

  const systemMetrics = [
    { title: 'Total Users', value: '45', change: '+3', icon: 'ri-user-line' },
    { title: 'Active Sessions', value: '23', change: '+5', icon: 'ri-computer-line' },
    { title: 'System Uptime', value: '99.9%', change: '+0.1%', icon: 'ri-server-line' },
    { title: 'Storage Used', value: '67%', change: '+2%', icon: 'ri-hard-drive-line' },
  ];

  const auditLogs = [
    { id: 1, user: 'Rajesh Kumar', action: 'Login', timestamp: '2024-01-20 10:30:00', ip: '192.168.1.100' },
    { id: 2, user: 'Priya Sharma', action: 'Updated User Role', timestamp: '2024-01-20 10:25:00', ip: '192.168.1.101' },
    { id: 3, user: 'Amit Patel', action: 'Approved Discount', timestamp: '2024-01-20 10:20:00', ip: '192.168.1.102' },
    { id: 4, user: 'System', action: 'Backup Completed', timestamp: '2024-01-20 02:00:00', ip: 'System' },
  ];

  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-primary">System Administration</h1>
        <div className="flex gap-3">
          <button className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary/90 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-download-line mr-2"></i>
            Export Logs
          </button>
          <button className="border border-primary text-primary px-4 py-2 rounded-lg hover:bg-primary/5 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-settings-line mr-2"></i>
            System Settings
          </button>
        </div>
      </div>

      {/* System Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {systemMetrics.map((metric, index) => (
          <div key={index} className="bg-white p-6 rounded-lg shadow-sm border">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">{metric.title}</p>
                <p className="text-2xl font-bold text-gray-900 mt-1">{metric.value}</p>
                <p className="text-sm text-green-600 mt-1">{metric.change}</p>
              </div>
              <div className="p-3 bg-primary/10 rounded-lg">
                <i className={`${metric.icon} text-primary text-xl`}></i>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Tab Navigation */}
      <div className="border-b border-gray-200">
        <nav className="flex space-x-8">
          {[
            { id: 'users', label: 'User Management', icon: 'ri-user-settings-line' },
            { id: 'permissions', label: 'Permissions', icon: 'ri-shield-user-line' },
            { id: 'audit', label: 'Audit Logs', icon: 'ri-file-list-line' },
            { id: 'backup', label: 'Backup & Security', icon: 'ri-shield-check-line' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                activeTab === tab.id
                  ? 'border-primary text-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <i className={`${tab.icon} mr-2`}></i>
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* User Management Tab */}
      {activeTab === 'users' && (
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="p-6 border-b flex justify-between items-center">
            <h2 className="text-xl font-semibold text-primary">User Management</h2>
            <button className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary/90 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-add-line mr-2"></i>
              Add User
            </button>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Name</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Role</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Email</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Status</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Last Login</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id} className="border-t">
                    <td className="px-6 py-4 font-medium">{user.name}</td>
                    <td className="px-6 py-4">{user.role}</td>
                    <td className="px-6 py-4">{user.email}</td>
                    <td className="px-6 py-4">
                      <span className={`px-2 py-1 rounded-full text-xs ${
                        user.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                      }`}>
                        {user.status}
                      </span>
                    </td>
                    <td className="px-6 py-4">{user.lastLogin}</td>
                    <td className="px-6 py-4">
                      <div className="flex gap-2">
                        <button className="text-blue-600 hover:text-blue-800 cursor-pointer">
                          <i className="ri-edit-line"></i>
                        </button>
                        <button className="text-red-600 hover:text-red-800 cursor-pointer">
                          <i className="ri-delete-bin-line"></i>
                        </button>
                        <button className="text-gray-600 hover:text-gray-800 cursor-pointer">
                          <i className="ri-lock-line"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Permissions Tab */}
      {activeTab === 'permissions' && (
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="p-6 border-b">
            <h2 className="text-xl font-semibold text-primary">Role Permissions</h2>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div>
                <h3 className="text-lg font-semibold mb-4">Roles</h3>
                <div className="space-y-2">
                  {['CEO', 'Director', 'Operations Head', 'HO Manager', 'Sales Head', 'Branch Manager'].map((role) => (
                    <div key={role} className="flex items-center justify-between p-3 border rounded-lg">
                      <span className="font-medium">{role}</span>
                      <button className="text-blue-600 hover:text-blue-800 cursor-pointer">
                        <i className="ri-edit-line"></i>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-4">Permissions</h3>
                <div className="space-y-3">
                  {[
                    'View Dashboard',
                    'Manage Users',
                    'Approve Discounts',
                    'Manage Inventory',
                    'View Reports',
                    'System Settings'
                  ].map((permission) => (
                    <div key={permission} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                      <span>{permission}</span>
                      <div className="flex gap-2">
                        <label className="flex items-center">
                          <input type="checkbox" className="mr-2" defaultChecked />
                          <span className="text-sm">Read</span>
                        </label>
                        <label className="flex items-center">
                          <input type="checkbox" className="mr-2" />
                          <span className="text-sm">Write</span>
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Audit Logs Tab */}
      {activeTab === 'audit' && (
        <div className="bg-white rounded-lg shadow-sm border">
          <div className="p-6 border-b">
            <h2 className="text-xl font-semibold text-primary">System Audit Logs</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">User</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Action</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Timestamp</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">IP Address</th>
                  <th className="px-6 py-3 text-left font-medium text-gray-900">Details</th>
                </tr>
              </thead>
              <tbody>
                {auditLogs.map((log) => (
                  <tr key={log.id} className="border-t">
                    <td className="px-6 py-4 font-medium">{log.user}</td>
                    <td className="px-6 py-4">{log.action}</td>
                    <td className="px-6 py-4">{log.timestamp}</td>
                    <td className="px-6 py-4">{log.ip}</td>
                    <td className="px-6 py-4">
                      <button className="text-blue-600 hover:text-blue-800 cursor-pointer">
                        <i className="ri-eye-line"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Backup & Security Tab */}
      {activeTab === 'backup' && (
        <div className="space-y-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <h2 className="text-xl font-semibold text-primary mb-4">Backup Management</h2>
              <div className="space-y-4">
                <div className="flex justify-between items-center p-3 border rounded-lg">
                  <div>
                    <h3 className="font-semibold">Daily Backup</h3>
                    <p className="text-sm text-gray-600">Last backup: 2024-01-20 02:00:00</p>
                  </div>
                  <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Active</span>
                </div>
                <div className="flex justify-between items-center p-3 border rounded-lg">
                  <div>
                    <h3 className="font-semibold">Weekly Backup</h3>
                    <p className="text-sm text-gray-600">Last backup: 2024-01-15 02:00:00</p>
                  </div>
                  <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Active</span>
                </div>
                <button className="w-full bg-primary text-white py-2 rounded-lg hover:bg-primary/90 transition-colors cursor-pointer">
                  Create Manual Backup
                </button>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <h2 className="text-xl font-semibold text-primary mb-4">Security Settings</h2>
              <div className="space-y-4">
                <div className="flex justify-between items-center p-3 border rounded-lg">
                  <span>Two-Factor Authentication</span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" className="sr-only peer" defaultChecked />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                  </label>
                </div>
                <div className="flex justify-between items-center p-3 border rounded-lg">
                  <span>Session Timeout (minutes)</span>
                  <input 
                    type="number" 
                    defaultValue="30" 
                    className="w-20 px-2 py-1 border rounded text-center"
                  />
                </div>
                <div className="flex justify-between items-center p-3 border rounded-lg">
                  <span>Password Complexity</span>
                  <select className="px-3 py-1 border rounded pr-8">
                    <option>High</option>
                    <option>Medium</option>
                    <option>Low</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}